exports.connect = {
	url: "https://api.campingaudinac.camp/"
}
